import { IRESTClient } from "./RESTClient";

/**
 * The Unit Testing and/or local development implmentation of the REST Client interface.
 * This is intended to be used when running the appllication locally or unit testing components to avoid invoking services.
 */
export class RestClientUT implements IRESTClient {
    private static Instance: IRESTClient;
    private static restApiBaseUri: string;
    private static IdToken: string;

    private constructor(restApiBaseUri: string) {RestClientUT.restApiBaseUri = restApiBaseUri}    
    
    async Authenticate(authCode: string): Promise<any> {
        let response = {"id_token": "11111"};
        RestClientUT.SetToken(response.id_token);
        return response;
    }

    static CreateInstance(restApiBaseUri:string) {
        if(RestClientUT.Instance)
            return RestClientUT.Instance;
            RestClientUT.Instance = new RestClientUT(restApiBaseUri);
        return RestClientUT.Instance
    }

    static SetToken(token: string) { RestClientUT.IdToken = token;}
    static GetIdToken() { return RestClientUT.IdToken || undefined; }
    static GetEndPoint() { return RestClientUT.restApiBaseUri; }

    async GetNumber(token: string): Promise<any> {
        var expirey = new Date(Date.now());
        expirey.setMinutes(expirey.getMinutes()+30);
        let response = {
            "phoneNumber": '+11235554321',
            "agentAssigned": 'agentSmith',
            "renewalAuthCode": '1337',
            "numberLeaseExpiresGMT": expirey.toISOString(),
            "loginUrlExpiresGMT": expirey.toISOString(),
            "loginUrl": 'http://localhost/foo/bar'
        }
        return response;
    }

    async RenewNumber(number: string, renewalCode: string, token: string): Promise<any> {
        var expirey = new Date(Date.now());
        expirey.setMinutes(expirey.getMinutes()+30);
        let response = {
            "phoneNumber": '+11235554321',
            "agentAssigned": 'agentSmith',
            "renewalAuthCode": '1337',
            "numberLeaseExpiresGMT": expirey.toISOString(),
            "loginUrlExpiresGMT": expirey.toISOString(),
            "loginUrl": 'http://localhost/foo/bar'
        }
        return response;
    }

    GetAgent(number: string, token: string): Promise<any> {
        throw new Error("Method not implemented.");
    }
}